/**
 * Converts a date string in DD/MM/YYYY format to UTC ISO format
 * @param {string} dateString - Date string in DD/MM/YYYY format (e.g., "25/02/2026")
 * @param {boolean} isEndOfDay - If true, sets time to 23:59:59.999, otherwise 00:00:00.000
 * @returns {string} ISO 8601 UTC date string (e.g., "2026-02-25T00:00:00.000Z")
 */
export const convertDateToUTC = (dateString, isEndOfDay = false) => {
    if (!dateString) return null;
    const formatDate = new Date(dateString).toLocaleDateString('en-GB'); // Returns "16/02/2026"

    const [day, month, year] = formatDate.split('/');
    const hours = isEndOfDay ? 23 : 0;
    const minutes = isEndOfDay ? 59 : 0;
    const seconds = isEndOfDay ? 59 : 0;
    const milliseconds = isEndOfDay ? 999 : 0;

    return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds, milliseconds)).toISOString();
};
export default convertDateToUTC;
